import jquery from "jquery";
window.jQuery = window.$ = jquery;

import "regenerator-runtime/runtime";

import axios from "axios";
import moment from 'moment';
import 'moment/locale/it'  // without this line it didn't work
moment.locale('it')


axios.defaults.headers = {
    'Content-Type': 'application/json;',
    "Access-Control-Allow-Origin": "*",
    "sula-app-code": ""
};
axios.defaults.headers['Authorization'] = `Bearer ${localStorage.getItem("srapptoken")}`;
axios.defaults.baseURL = window.baseurl;
import Vue from "vue";
import vSelect from 'vue-select'
import Swal from "sweetalert2";
import _ from 'lodash';
import ticketwizard from './views/wizard.vue';


Vue.component('v-select', vSelect)
Vue.component('ticketwizard', ticketwizard)


$(function () {
    const ticketWizard = document.getElementById("ticket-wizard");
    if (ticketWizard) {
        const ticketwizardapp = new Vue({
            el: "#ticket-wizard",
            data() {
                return {
                 
                };
            },
            components: {},
            mounted() {
                
            },
            methods: {
              

            }
        });
    }
});



